import { Injectable, Injector } from '@angular/core';

import { ContaCorrenteModel } from '@models/financeiro/conta-corrente.model';
import { HelpConfig } from '@config/help-config';
import { BaseResourceService } from '@core/services/outros/base-resource.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ContaCorrenteService extends BaseResourceService<ContaCorrenteModel> {

  constructor(
    protected injector: Injector,
    private helpConfig: HelpConfig
  ) {
    super(`${helpConfig.FINANCIAL_API}contascorrentes`, injector);
  }
  getContaCorrenteSindauto(params?: {[param: string]: any }): Observable<ContaCorrenteModel[]> {
    return this._httpClient.get<ContaCorrenteModel[]>(`${this._url}?Sindicato=true`, { params });
  }
}
